import { useState } from 'react';
import { Container, Grid } from '@mui/material';
import '../styles.scss';

export default function Pregunta9({ setRespuesta, cambiarPregunta, sumarPuntos }) {
	const [seleccionadas, setSeleccionada] = useState([]);
	const [btn1, setBtn1] = useState(false);
	const [btn2, setBtn2] = useState(false);
	const [btn3, setBtn3] = useState(false);
	const [btn4, setBtn4] = useState(false);
	const [correctas] = useState(['b) Delegador: Permitirle trabajar de forma independiente.']);

	const grabarSeleccionada = (opc) => {
		const array = seleccionadas;
		array.push(opc);
		array.sort();
		setSeleccionada(array);
	};

	const siguiente = () => {
		if (seleccionadas.toString() === correctas.toString()) {
			setRespuesta('pregunta9', seleccionadas, 1);
			console.log('si');

			sumarPuntos(1);
		} else {
			setRespuesta('pregunta9', seleccionadas, 0);
			console.log('no');

			sumarPuntos(0);
		}
		cambiarPregunta(10);
	};

	const seleccionarOpcion = (btn) => {
		if (btn === 1) {
			setBtn1(!btn1);
			setBtn2(false);
			setBtn3(false);
			setBtn4(false);
		}
		if (btn === 2) {
			setBtn1(false);
			setBtn2(!btn2);
			setBtn3(false);
			setBtn4(false);
		}
		if (btn === 3) {
			setBtn1(false);
			setBtn2(false);
			setBtn3(!btn3);
			setBtn4(false);
		}
		if (btn === 4) {
			setBtn1(false);
			setBtn2(false);
			setBtn3(false);
			setBtn4(!btn4);
		}
	};

	return (
		<>
			<Container maxWidth='lg'>
				<Grid container justifyContent='center' alignItems='center' spacing={4}>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div className='pregunta'>
							<div className='num-pregunta'>9.</div> Un asesor con poca experiencia y baja confianza necesita preparar una presentación para un cliente importante. Como su líder, ¿qué estilo de liderazgo aplicarías para guiarlo?
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div
							className={`${btn1 ? 'disable' : ''} texto-pregunta`}
							onClick={() => {
								seleccionarOpcion(1);
								grabarSeleccionada('a) Directivo: Brindar instrucciones claras y supervisar cada paso.');
							}}
						>
							<div className='letra'>{`a)`}</div>
							<div className='texto-respuesta'>Directivo: Brindar instrucciones claras y supervisar cada paso.</div>
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div
							className={`${btn2 ? 'disable' : ''} texto-pregunta`}
							onClick={() => {
								seleccionarOpcion(2);
								grabarSeleccionada('b) Delegador: Permitirle trabajar de forma independiente.');
							}}
						>
							<div className='letra'>{`b)`}</div>
							<div className='texto-respuesta'>Delegador: Permitirle trabajar de forma independiente.</div>
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div
							className={`${btn3 ? 'disable' : ''} texto-pregunta`}
							onClick={() => {
								seleccionarOpcion(3);
								grabarSeleccionada('c) Participativo: Colaborar con él para planificar y ejecutar la presentación.');
							}}
						>
							<div className='letra'>{`c)`}</div>
							<div className='texto-respuesta'> Participativo: Colaborar con él para planificar y ejecutar la presentación.</div>
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div
							className={`${btn4 ? 'disable' : ''} texto-pregunta`}
							onClick={() => {
								seleccionarOpcion(4);
								grabarSeleccionada('d) Persuasivo: Convencerlo de que tiene las habilidades necesarias y observar su progreso.');
							}}
						>
							<div className='letra'>{`d)`}</div>
							<div className='texto-respuesta'> Persuasivo: Convencerlo de que tiene las habilidades necesarias y observar su progreso.</div>
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div className='siguiente' onClick={() => siguiente()}>
							Siguiente
						</div>
					</Grid>
				</Grid>
			</Container>
		</>
	);
}
